module.exports = "/images/wm-team-anders-shadow.5ef02a9de8594b0e90ddb4d1be83005f.png";